<template>
	<div class="student-container">
		<div class="student-title">
			<span>学生信息</span>
			<span class="flex-empty"></span>
			<div v-if="studentId">
				<a-button v-if="!isEditStudent" class="fr" icon="edit" @click="isEditStudent = true">编辑</a-button>
				<a-button type="primary" v-if="isEditStudent" class="fr m-left-20" @click="updateStudentInfoHandle"
					:disabled="hasStudentInfoChange">提交</a-button>
				<a-button v-if="isEditStudent" class="fr" @click="resetStudentInfo">取消</a-button>
			</div>
		</div>
		<div class="student-info student-info_edit" v-if="!studentId || isEditStudent">
			<div class="dis-line">
				<span class="student-label required-field">学生姓名</span>
				<a-input class="student-input" v-model="studentInfo.kid_name" placeholder="请输入学生姓名" />
			</div>
			<div class="dis-line m-left-100">
				<span class="student-label required-field">班级</span>
				<a-select class="student-select" v-model="studentInfo.klass_id" :disabled="!!studentId"
					placeholder="请选择所属班级">
					<a-select-option v-for="item in klassList" :value="item.id" :key="item.id">
						{{ item.name }}
					</a-select-option>
				</a-select>
			</div>
			<br />
			<div class="dis-line">
				<span class="student-label">出生日期</span>
				<a-date-picker class="student-input" v-model="studentInfo.birth_date" placeholder="请选择出生日期"
					allowClear />
			</div>
			<div class="dis-line m-left-100">
				<span class="student-label">性别</span>
				<a-select class="student-select" v-model="studentInfo.gender" placeholder="请选择性别" allowClear>
					<a-select-option value="MALE" key="MALE">男</a-select-option>
					<a-select-option value="FEMALE" key="FEMALE">女</a-select-option>
				</a-select>
			</div>
			<br />
			<div class="dis-line">
				<span class="student-label">家庭住址</span>
				<a-input class="student-input" v-model="studentInfo.home_address" placeholder="请输入家庭住址" allowClear />
			</div>
			<div class="dis-line m-left-100">
				<span class="student-label">入学日期</span>
				<a-date-picker class="student-select" v-model="studentInfo.admission_date" placeholder="请选择入学日期"
					allowClear />
			</div>
		</div>

		<div class="student-info" v-else>
			<div class="dis-line student-item">
				<span class="student-item_label">学生姓名</span>
				<span class="student-item_value">{{ studentInfo.kid_name || "--" }}</span>
			</div>
			<div class="dis-line student-item m-left-100">
				<span class="student-item_label">班级</span>
				<span class="student-item_value">{{ getKlassName(studentInfo.klass_id) || "--" }}</span>
			</div>
			<br />
			<div class="dis-line student-item">
				<span class="student-item_label">出生日期</span>
				<span class="student-item_value" v-if="studentInfo.birth_date">
					{{ studentInfo.birth_date | timeFormat }}
				</span>
				<span v-else>--</span>
			</div>
			<div class="dis-line student-item m-left-100">
				<span class="student-item_label">性别</span>
				<span class="student-item_value">{{ GENDER_MAP[studentInfo.gender] || "--" }}</span>
			</div>
			<br />
			<div class="dis-line student-item">
				<span class="student-item_label">家庭住址</span>
				<span class="student-item_value">{{ studentInfo.home_address || "--" }}</span>
			</div>
			<div class="dis-line student-item m-left-100">
				<span class="student-item_label">入学日期</span>
				<span class="student-item_value" v-if="studentInfo.admission_date">
					{{ studentInfo.admission_date | timeFormat }}
				</span>
				<span v-else>--</span>
			</div>

			<span v-if="!isAccept" class="student-operate student-del m-right-20" @click="delStudentHandle">
				<a-icon type="delete" />
			</span>
		</div>

		<div class="student-title">
			<span>家长信息</span>
			<span class="flex-empty"></span>
			<a-button class="fr" icon="edit" @click="clickHandle">添加家长</a-button>
			<a-button v-if="studentId" type="primary" class="fr m-left-20" :disabled="!hasKinsfolkChange"
				@click="updateKinsfolkHandle">提交</a-button>
		</div>

		<div class="student-kinsfolk">
			<div v-for="(kinsfolkInfo, index) in kinsfolkList" :key="index">
				<div v-if="!kinsfolkInfo.id || kinsfolkInfo.isEdit">
					<div class="dis-line">
						<span class="student-label">家长姓名</span>
						<a-input class="student-input" v-model="kinsfolkInfo.name" :disabled="!!kinsfolkInfo.id"
							placeholder="请输入家长姓名" />
					</div>
					<div class="dis-line m-left-100">
						<span class="student-label">亲属关系</span>
						<a-select class="student-select" v-model="kinsfolkInfo.relationship_id" placeholder="请选择亲属关系">
							<a-select-option v-for="item in relationshipList" :value="item.id" :key="item.id">
								{{ item.name }}
							</a-select-option>
						</a-select>
					</div>
					<br />
					<div class="dis-line">
						<span class="student-label required-field">
							手机号
							<span class="student-error">{{ kinsfolkInfo.message }}</span>
						</span>
						<a-input class="student-input" v-model="kinsfolkInfo.mobile" :disabled="!!kinsfolkInfo.id"
							placeholder="请输入手机号" />
					</div>
					<span class="student-operate student-del m-right-20" @click="delHandle(index)"
						v-if="kinsfolkList.length > 1">
						<a-icon type="delete" />
					</span>
					<div class="student-deliver" v-if="kinsfolkList.length > 1 && index != kinsfolkList.length - 1">
					</div>
				</div>

				<div v-else>
					<div class="dis-line student-item">
						<span class="student-item_label">家长姓名</span>
						<span class="student-item_value">
							{{ computedKInsfolkInfo(kinsfolkInfo, "name") }}
						</span>
					</div>
					<div class="dis-line student-item m-left-100">
						<span class="student-item_label">认证状态</span>
						<span :class="`student-item_value AUTH_STATUS_${kinsfolkInfo.status}`">
							{{ KINSFOLK_STATUS[kinsfolkInfo.status] || "--" }}
						</span>
					</div>
					<br />
					<div class="dis-line student-item">
						<span class="student-item_label">亲属关系</span>
						<span class="student-item_value">
							{{ computedKInsfolkInfo(kinsfolkInfo, "relationship") }}
						</span>
					</div>
					<div class="dis-line student-item m-left-100">
						<span class="student-item_label">手机号</span>
						<span class="student-item_value">
							{{ kinsfolkInfo.mobile || "--" }}
						</span>
					</div>
					<span v-if="kinsfolkInfo.status !== 'ACCEPTED'" class="student-operate student-del m-right-20"
						@click="delKinsfolkHandle(kinsfolkInfo)">
						<a-icon type="delete" title="删除" />
					</span>
					<div class="student-deliver" v-if="kinsfolkList.length > 1 && index != kinsfolkList.length - 1">
					</div>
				</div>
			</div>
			<a-empty class="p-top-30" v-if="!kinsfolkList.length" />
		</div>

		<div class="student-title" v-if="studentId">
			<span>在校状态</span>
			<span class="flex-empty"></span>
			<a-button class="fr" icon="edit" @click="showStatusModal">编辑状态</a-button>
		</div>

		<div class="student-status" v-if="studentId">
			<div class="dis-line student-item">
				<span class="student-item_label">在校状态</span>
				<span :class="`student-item_value STUDENT_STATUS_${studentInfo.status}`">{{
					STUDENT_STATUS[studentInfo.status]
				}}</span>
			</div>
		</div>

		<div class="student-title" v-if="studentId">
			<span>状态记录</span>
			<span class="flex-empty"></span>
			<a-button class="fr" icon="edit" @click="editLogHandle()">添加记录</a-button>
		</div>

		<div class="student-status student-statuslog" v-if="studentId">
			<div v-for="(item, index) in statusLogList" :key="item.id">
				<div class="student-item">
					<span class="student-item_value">
						{{ STUDENT_STATUS[item.status] }}
					</span>

					<span class="dis-line m-left-90 width-200" v-if="item.start_date && item.end_date">{{
						item.start_date | timeFormat
					}} ~ {{ item.end_date | timeFormat }}</span>
					<span class="dis-line m-left-90 width-200" v-else-if="item.start_date">{{
						item.start_date |
							timeFormat
					}} ~ 至今</span>
					<span class="dis-line m-left-90 width-200" v-else-if="item.end_date">-- ~ {{
						item.end_date |
							timeFormat
					}}</span>
					<span class="dis-line m-left-90 width-200" v-else>--</span>
					<span class="m-left-90">{{ item.comment }}</span>
					<span class="student-operate student-del m-right-20" @click="delLogHandle(item)">
						<a-icon type="delete" />
					</span>
					<span class="student-operate student-edit m-right-20" @click="editLogHandle(item)">
						<a-icon type="edit" />
					</span>
				</div>

				<div class="student-deliver m-top-20 m-bottom-20"
					v-if="statusLogList.length > 1 && index != statusLogList.length - 1">
				</div>
			</div>
			<a-empty class="p-top-30" v-if="!statusLogList.length" />
		</div>

		<a-button v-if="!studentId" class="submit-btn" @click="submitHandle">确定</a-button>

		<a-modal title="编辑在校状态" v-model="statusModal.visible" :confirm-loading="statusModal.loading"
			@ok="updateStudentStatusHandle()" @cancel="resetModal('statusModal')">
			<div class="student-modal_item">
				<span class="student-modal_label required-field">新状态</span>
				<a-select class="width-300" v-model="statusModal.status" placeholder="请选择状态">
					<a-select-option v-for="(value, key) in STUDENT_STATUS" :value="key" :key="key">
						{{ value }}
					</a-select-option>
				</a-select>
			</div>
			<div class="student-modal_item m-top-20">
				<span class="student-modal_label"></span>
				<a-checkbox :checked="statusModal.checked"
					@change="(e) => statusModal.checked = e.target.checked">同步添加记录</a-checkbox>
			</div>
		</a-modal>

		<a-modal :title="statusLogModal.title" v-model="statusLogModal.visible"
			:confirm-loading="statusLogModal.loading" @ok="createStudentLogHandle"
			@cancel="resetModal('statusLogModal')">
			<div class="student-modal_item">
				<span class="student-modal_label required-field">新状态</span>
				<a-select class="width-300" v-model="statusLogModal.status" placeholder="请选择任新状态">
					<a-select-option v-for="(value, key) in STUDENT_STATUS" :value="key" :key="key">
						{{ value }}
					</a-select-option>
				</a-select>
			</div>

			<div class="student-modal_item">
				<span class="student-modal_label">开始日期</span>
				<a-date-picker class="width-300" v-model="statusLogModal.start_date" placeholder="请选择开始日期" allowClear />
			</div>

			<div class="student-modal_item">
				<span class="student-modal_label">结束日期</span>
				<a-date-picker class="width-300" v-model="statusLogModal.end_date" placeholder="请选择结束日期" allowClear />
			</div>

			<div class="student-modal_item">
				<span class="student-modal_label">调整原因</span>
				<a-input class="width-300" v-model="statusLogModal.comment" placeholder="请输入调整原因" />
			</div>

			<div class="student-modal_item  m-top-20">
				<span class="student-modal_label"></span>
				<a-checkbox :checked="statusLogModal.checked"
					@change="(e) => statusLogModal.checked = e.target.checked">同步更新状态</a-checkbox>
			</div>
		</a-modal>
	</div>
</template>
  
<script>
import { mapGetters } from "vuex";
import StudentService from "@/api/studentService";
import dict from "@/config";

export default {
	name: "student",
	components: {},
	data() {
		return {
			isloading: true,
			klassId: undefined,
			studentId: undefined,
			originStudentInfo: {},
			studentInfo: {
				kid_name: undefined,
				klass_id: undefined,
				birth_date: undefined,
				gender: undefined,
				home_address: undefined,
				admission_date: undefined,
			},
			kinsfolkList: [],
			isEditStudent: false,
			GENDER_MAP: dict.GENDER_MAP,
			STUDENT_STATUS: dict.STUDENT_STATUS,
			KINSFOLK_STATUS: dict.KINSFOLK_STATUS,
			statusModal: {
				visible: false,
				loading: false,
				checked: false,
				status: undefined,
			},
			statusLogModal: {
				title: "新建状态记录",
				status: undefined,
				visible: false,
				loading: false,
				checked: false,
				comment: undefined,
				start_date: null,
				end_date: null,
			},
			statusLogList: [],
		};
	},

	computed: {
		...mapGetters(["klassList", "relationshipList"]),
		getKlassName() {
			return function (id) {
				const klassInfo =
					this.klassList.find((item) => item.id === id) || {};
				return klassInfo.name;
			};
		},
		isAccept() {
			return (
				this.kinsfolkList.filter((item) => item.status === "ACCEPTED")
					.length > 0
			);
		},

		hasStudentInfoChange() {
			return JSON.stringify(this.originStudentInfo) === JSON.stringify(this.studentInfo)
		},

		hasKinsfolkChange() {
			const kinsfolkList = this.kinsfolkList
				.filter((item) => item.mobile && item.mobile.trim() && !item.id);
			return kinsfolkList.length > 0
		},

		computedKInsfolkInfo () {
			return function (kinsfolkInfo, type) {
				if (kinsfolkInfo.status !== 'ACCEPTED') {
					return kinsfolkInfo[type] || "--";
				}

				if (kinsfolkInfo[type] === kinsfolkInfo.matched_kinsfolk[type]) return kinsfolkInfo[type] || "--";
				return `${kinsfolkInfo[type]} / ${kinsfolkInfo.matched_kinsfolk[type]}`
			}
		}
	},

	created() {
		this.initHandle();
	},

	methods: {
		initHandle() {
			if (!this.relationshipList.length) {
				setTimeout(() => {
					this.initHandle();
				}, 1000);
				return;
			}
			this.isEditStudent = false;
			const { klass_id, student_id } = this.$route.query;
			this.klassId = klass_id;
			this.studentId = student_id;
			if (student_id) {
				this.getStudentHandle();
				this.getStatusLog();
			} else {
				this.clickHandle();
			}
			this.$store.dispatch("getKlassListService");
		},
		getStudentHandle(type) {
			this.isloading = true;
			StudentService.getStudentService({
				studentId: this.studentId,
			}).then((res) => {
				this.isloading = false;
				const { kinsfolk_info_from_teacher_list, ...studentInfo } = res;
				if (!type || type === "studentInfo") {
					this.studentInfo = studentInfo;
					this.originStudentInfo = JSON.parse(
						JSON.stringify(studentInfo)
					);
				}
				if (!type || type === "kinsfolk") {
					this.kinsfolkList = kinsfolk_info_from_teacher_list.map(
						(item) => {
							item.isEdit = false;
							item.relationship_id = (
								this.relationshipList.find(
									(relationship) =>
										relationship.name === item.relationship
								) || {}
							).id;
							return item;
						}
					);
				}
			}).catch(() => {
				this.isloading = false;
			});
		},

		clickHandle() {
			this.kinsfolkList.push({
				name: undefined,
				relationship: undefined,
				mobile: undefined,
			});
		},

		delHandle(index) {
			this.kinsfolkList.splice(index, 1);
		},

		async submitHandle() {
			let status = true;
			if (
				!this.studentInfo.kid_name ||
				!this.studentInfo.kid_name.trim()
			) {
				this.studentInfo.message = "学生姓名不可为空";
				status = false;
				return;
			}
			this.kinsfolkList.forEach((item) => {
				const mobile = (item.mobile && item.mobile.trim()) || "";
				if (mobile.length && mobile.length !== 11) {
					item.message = "请输入合法的11位手机号";
					status = false;
				} else {
					item.message = "";
				}
			});
			if (!status) {
				this.$forceUpdate();
				return;
			}

			delete this.studentInfo.message;
			this.studentInfo.kid_name = this.studentInfo.kid_name.trim();
			if (this.studentInfo.home_address) {
				this.studentInfo.home_address = this.studentInfo.home_address.trim();
			}

			const kinsfolkList = this.kinsfolkList
				.filter((item) => item.mobile && item.mobile.trim())
				.map((item) => {
					item.mobile = item.mobile.trim();
					if (item.name) {
						item.name = item.name.trim();
					}
					delete item.message;
					return item;
				});

			StudentService.createStudentService({
				...this.studentInfo,
				kinsfolk_list_from_teacher: kinsfolkList,
			}).then(() => {
				this.$message.success("添加成功");
				this.$router.back();
			});
		},

		updateStudentInfoHandle() {
			if (!this.studentInfo.kid_name || !this.studentInfo.kid_name.trim()) {
				this.$message.warning("学生姓名不可为空");
				return;
			}

			delete this.studentInfo.message;
			this.studentInfo.kid_name = this.studentInfo.kid_name.trim();
			if (this.studentInfo.home_address) {
				this.studentInfo.home_address = this.studentInfo.home_address.trim();
			}

			StudentService.updateStudentService({
				...this.studentInfo,
				studentId: this.studentId,
			}).then(() => {
				this.$message.success("更新成功");
				this.isEditStudent = false;
				this.getStudentHandle("studentInfo");
			});
		},

		updateKinsfolkHandle() {
			let status = true;
			this.kinsfolkList.filter((item) => !item.id).forEach((item) => {
				const mobile = (item.mobile && item.mobile.trim()) || "";
				if (mobile.length && mobile.length !== 11) {
					item.message = "请输入合法的11位手机号";
					status = false;
				} else {
					item.message = "";
				}
			});
			if (!status) {
				this.$forceUpdate();
				return;
			}

			const kinsfolkList = this.kinsfolkList
				.filter((item) => item.mobile && item.mobile.trim() && !item.id)
				.map((item) => {
					item.mobile = item.mobile.trim();
					if (item.name) {
						item.name = item.name.trim();
					}
					delete item.message;
					return item;
				});

			StudentService.createKinsfolkService({
				studentId: this.studentId,
				kinsfolkList,
			}).then(() => {
				this.getStudentHandle("kinsfolk");
			});
		},

		delStudentHandle() {
			this.$confirm({
				title: "提示信息",
				content: `是否删除当前学生 ${this.studentInfo.kid_name}`,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						StudentService.deactivateStudentService({
							studentId: this.studentInfo.id,
						})
							.then(() => {
								this.$message.success("删除成功");
								this.$router.back();
								resolve();
							})
							.catch(() => {
								reject();
								this.$message.error("操作失败，请重新操作");
							});
					});
				},
			});
		},

		delKinsfolkHandle(kinsfolk) {
			this.$confirm({
				title: "提示信息",
				content: `是否删除当前家长 ${kinsfolk.name}`,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						StudentService.delKinsfolkService({ id: kinsfolk.id })
							.then(() => {
								this.$message.success("删除成功");
								const index = this.kinsfolkList.findIndex(item => item.id === kinsfolk.id);
								this.kinsfolkList.splice(index, 1);
								resolve();
							})
							.catch(() => {
								reject();
								this.$message.error("操作失败，请重新操作");
							});
					});
				},
			});
		},

		showStatusModal() {
			Object.assign(this.statusModal, {
				visible: true,
				status: this.studentInfo.status,
				checked: false,
			});
		},

		updateStudentStatusHandle(status) {
			this.statusModal.loading = true;
			StudentService.updateStudentStatusService({
				studentId: this.studentId,
				status: status || this.statusModal.status,
			})
				.then(() => {
					this.$message.success("修改成功");
					this.statusModal.visible = true;
					this.statusModal.loading = true;
					this.studentInfo.status = status || this.statusModal.status;
					this.resetModal("statusModal");
				})
				.catch(() => {
					this.$message.error("操作失败，请稍后重试");
					this.statusModal.loading = true;
					this.statusModal.checked = true;
				});

			if (this.statusModal.checked) {
				this.statusLogModal.status = this.statusModal.status;
				this.statusLogModal.start_date = moment();
				this.createStudentLogHandle();
			}
		},

		getStatusLog() {
			StudentService.getStatusLogListService({
				student_id: this.studentId,
			}).then((res) => {
				this.statusLogList = res;
			});
		},

		createStudentLogHandle() {
			if (!this.statusLogModal.status) {
				this.$message.warning("请选择新状态");
				return;
			}

			const params = {
				student_id: this.studentId,
				...this.statusLogModal,
			};
			if (params.status === "TRANSFERRED_IN") {
				params.next_klass_id = this.klassId;
			} else if (params.status === "TRANSFERRED_OUT") {
				params.pre_klass_id = this.klassId;
			}

			if (this.statusLogModal.id) {
				StudentService.updateStatusLogService(params).then(() => {
					this.$message.success("操作成功");
					this.getStatusLog();
					this.resetModal();
				})
					.catch(() => {
						this.$message.error("操作失败，请稍后重试");
						this.statusLogModal.loading = true;
						this.statusLogModal.checked = false;
					});
			} else {
				StudentService.createStatusLogService(params).then(() => {
					this.$message.success("操作成功");
					this.getStatusLog();
					this.resetModal();
				})
					.catch(() => {
						this.$message.error("操作失败，请稍后重试");
						this.statusLogModal.loading = true;
						this.statusLogModal.checked = false;
					});
			}

			if (this.statusLogModal.checked) {
				this.updateStudentStatusHandle(this.statusLogModal.status);
			}
		},

		delLogHandle(statusLog) {
			this.$confirm({
				title: "提示信息",
				content: "确认删除当前状态记录？",
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						StudentService.delStatusLogService({
							id: statusLog.id,
						})
							.then(() => {
								this.$message.success("操作成功");
								this.getStatusLog();
								resolve();
							})
							.catch(() => {
								reject();
								this.$message.error("操作失败，请重新操作");
							});
					});
				},
			});
		},

		editLogHandle(statusLog) {
			if (!statusLog) {
				this.statusLogModal.visible = true;
				return;
			}
			const { start_date, end_date, comment, status, id } = statusLog;
			const endDate = end_date ? moment(end_date) : null;
			const startDate = start_date ? moment(start_date) : null;
			Object.assign(this.statusLogModal, {
				title: "修改状态记录",
				visible: true,
				id,
				status,
				comment,
				start_date: startDate,
				end_date: endDate,
			});
		},

		resetModal(type) {
			if (type === "statusModal") {
				this.statusModal = {
					visible: false,
					loading: false,
					checked: false,
					status: undefined,
				};
			} else {
				this.statusLogModal = {
					title: "新建状态记录",
					visible: false,
					loading: false,
					checked: false,
					status: undefined,
					comment: undefined,
					start_date: null,
					end_date: null,
				};
			}
		},

		resetStudentInfo() {
			this.isEditStudent = false;
			this.studentInfo = JSON.parse(
				JSON.stringify(this.originStudentInfo)
			);
		},
	},
};
</script>
  
<style lang="less" scoped>
.student {
	&-container {
		// height: calc(100% - 49px);
		padding-right: 100px;
		// padding-bottom: 30px;
		background: #f0f2f5;

		.required-field {
			&::before {
				position: relative;
				top: 3px;
				display: inline-block;
				content: "*";
				margin-right: 8px;
				color: red;
			}
		}
	}

	&-title {
		display: flex;
		flex-flow: nowrap row;
		align-items: center;
		height: 32px;
		padding: 15px 0;
		box-sizing: content-box;
		line-height: 32px;
		background: #f0f2f5;

		&::before {
			position: relative;
			top: 0px;
			display: inline-block;
			content: "";
			width: 6px;
			height: 6px;
			margin-right: 8px;
			background: #409eff;
			border-radius: 50%;
		}
	}

	&-info {
		height: 168px;
		padding: 0 0 10px 60px;
		border-radius: 8px;
		background: #ffffff;

		&_edit {
			height: 290px;
		}
	}

	&-label {
		display: block;
		height: 20px;
		margin: 22px 0 14px;
		font-size: 14px;
		color: #343c6a;
	}

	&-input {
		width: 360px;
		height: 32px;
		border-radius: 4px;
		border-color: #d5d5d5;
	}

	&-select {
		width: 270px;
		height: 32px;
		border-radius: 4px;
		border-color: #d5d5d5;
	}

	&-kinsfolk {
		min-height: 120px;
		padding: 0 0 22px 60px;
		border-radius: 8px;
		background: #ffffff;
	}

	&-btn {
		border-radius: 8px;
	}

	&-operate {
		float: right;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		text-align: center;
		color: #ffffff;
		line-height: 40px;
		cursor: pointer;
	}

	&-del {
		background: #fe5c73;
	}

	&-edit {
		background: #ffa647;
	}

	&-accept {
		background: #1ab752;
	}

	&-decline {
		background: #fe5c73;
		font-size: 20px;
	}

	&-deliver {
		height: 1px;
		margin: 30px 0 10px;
		background: #d4d4d4;
	}

	&_submit {
		display: block;
		width: 370px;
		height: 56px;
		margin: 35px auto;
		border-radius: 8px;
		background: linear-gradient(270deg,
				#04b2fa -10%,
				#037cfe 28%,
				#0169fc 101%);
		color: #ffffff;

		&:hover {
			background: linear-gradient(270deg,
					#04b2fa -10%,
					#037cfe 28%,
					#0169fc 101%);
			color: #ffffff;
		}

		&:active {
			background: linear-gradient(270deg,
					#04b2fa -10%,
					#037cfe 28%,
					#0169fc 101%);
			color: #ffffff;
		}
	}

	&-message {
		&_error {
			color: red;
			font-size: 12px;
		}
	}

	&-item {
		width: 400px;

		&_label {
			display: inline-block;
			width: 120px;
			height: 20px;
			margin: 22px 0 5px;
			font-size: 14px;
			line-height: 20px;
			color: #343c6a;
			font-weight: bold;
		}
	}

	&-status {
		min-height: 65px;
		padding: 0 0 0 60px;
		border-radius: 8px;
		background: #ffffff;
	}

	&-statuslog {
		padding: 20px 0 20px 60px;

		.student-item {
			width: 100%;
			height: 40px;
			line-height: 40px;
		}
	}

	&-modal {
		&_item {
			display: flex;
			flex-flow: nowrap row;
			align-items: center;
			margin-bottom: 20px;
		}

		&_label {
			width: 80px;
			margin-right: 20px;
			text-align: right;
		}
	}

	&-error {
		color: red;
	}
}

@media screen and (max-width: 1980px) {

	.student-input,
	.student-item {
		width: 300px;
	}

	.student-statuslog .student-item {
		width: 100%;
	}
}

@media screen and (max-width: 1440px) {

	.student-input,
	.student-item {
		width: 220px;
	}

	.student-statuslog .student-item {
		width: 100%;
	}
}
</style>
